import React from "react";
import Overview from "../tabs-components/overview";
import Fuels from "../tabs-components/fuels";
import Meters from "../tabs-components/meters";
import Expenses from "../tabs-components/expenses";
import Services from "../tabs-components/services";
import Incidents from "../tabs-components/incidents";
import Media from "../tabs-components/media/media";
import Settings from "../tabs-components/settings";
import Tires from "../tabs-components/tires";
import ReminderTable from "../../../../pages/reminders/reminder-table";
import ServiceConfigs from "../tabs-components/serviceConfig";
import RenewalTable from "../../../..//pages/renewals/renewal-table";

const VehicleViewTabsConfig = ({
    vehicle,
    vehicleId,
    accountId,
    searchTerm,
    setSearchTerm,
    newlyAddedItem,
    setNewlyAddedItem,
    fuelData,
    setFuelData,
    meterData,
    setMeterData,
    setTireData,
    tireData,
    tirePositions,
    setTirePositions,
    tireUnAssign,
    setTireUnAssign,
    expenseData,
    setExpenseData,
    IncidentData,
    setIncidentData,
    tabStates,
    fetchTabData,
    users,
    vehicles,
    reminderData,
    setReminderData,
    renewalData,
    setRenewalData,
    renewalTypes,
    setRenewalTypes,
    vendors,
    categories,
    serviceData,
    meterTypes,
    setMeterTypes,
    setServiceData,
    serviceConfigData,
    setServiceConfigData,
    paymentMethods,
    jobsOptions,
    typesOptions,
    media,
    mediaError,
    handleRemoveImage,
    collapsed
}) => {
    

    const TABS = [
        {
            name: "Overview",
            component: <Overview vehicleId={vehicleId} vehicleDetails={vehicle} />,
        },
        {
            name: "Fuels",
            component: (
                <Fuels
                    loading={tabStates.Fuels.loading}
                    error={tabStates.Fuels.error}
                    data={fuelData}
                    setData={setFuelData}
                    newlyAddedItem={newlyAddedItem}
                    setNewlyAddedItem={setNewlyAddedItem}
                    globalFilter={searchTerm}
                    onGlobalFilterChange={setSearchTerm}
                    spendors={users}
                    vendors={vendors}
                    vehicles={vehicles}
                    accountId={accountId}
                    fetchFuels={fetchTabData}
                />
            ),
        },
        {
            name: "Meters",
            component: (
                <Meters
                    data={meterData}
                    newlyAddedItem={newlyAddedItem}
                    setNewlyAddedItem={setNewlyAddedItem}
                    globalFilter={searchTerm}
                    onGlobalFilterChange={setSearchTerm}
                    loading={tabStates.Meters.loading}
                    error={tabStates.Meters.error}
                    setData={setMeterData}
                    spendors={users}
                    vendors={vendors}
                    types={meterTypes}
                    vehicles={vehicles}
                    accountId={accountId}
                    fetchMeters={fetchTabData}
                />
            ),
        },
        {
            name: "Expenses",
            component: (
                <Expenses
                    data={expenseData}
                    newlyAddedItem={newlyAddedItem}
                    setNewlyAddedItem={setNewlyAddedItem}
                    globalFilter={searchTerm}
                    onGlobalFilterChange={setSearchTerm}
                    loading={tabStates.Expenses.loading}
                    error={tabStates.Expenses.error}
                    setData={setExpenseData}
                    spendors={users}
                    vendors={vendors}
                    vehicles={vehicles}
                    jobsOptions={jobsOptions}
                    accountId={accountId}
                    fetchExpenses={fetchTabData}
                    categories={categories}
                    paymentMethods={paymentMethods}
                />
            ),
        },
        {
            name: "Reminders",
            component: (
                <ReminderTable
                    accountId={accountId}
                    data={reminderData}
                    setData={setReminderData}
                    globalFilter={searchTerm}
                    fetchData={fetchTabData}
                    onGlobalFilterChange={setSearchTerm}
                    error={mediaError}
                    collapsed={collapsed}
                    isVehicle={true}
                />
            ),
        },

        {
            name: "Services", component: (
                <Services
                    loading={tabStates.Services.loading}
                    error={tabStates.Services.error}
                    data={serviceData}
                    setData={setServiceData}
                    newlyAddedItem={newlyAddedItem}
                    setNewlyAddedItem={setNewlyAddedItem}
                    globalFilter={searchTerm}
                    onGlobalFilterChange={setSearchTerm}
                    vendors={vendors}
                    vehicles={vehicles}
                    accountId={accountId}
                    fetchServices={fetchTabData}
                />
            )
        },
        {
            name: "Renewals",
            // component: <Renewals data={filteredRenewalsData} />,
            component: <RenewalTable
                data={renewalData}
                setData={setRenewalData}
                globalFilter={searchTerm}
                onGlobalFilterChange={setSearchTerm}
                newlyAddedItem={newlyAddedItem}
                setNewlyAddedItem={setNewlyAddedItem}
                fetchRenewals={fetchTabData}
                loadingData={tabStates.Renewals.loading}
                accountId={accountId}
                vendors={vendors}
                vehicles={vehicles}
                types={renewalTypes}
            />,
        },
        {
            name: "Incidents",
            component: (
                <Incidents
                    data={IncidentData}
                    newlyAddedItem={newlyAddedItem}
                    setNewlyAddedItem={setNewlyAddedItem}
                    globalFilter={searchTerm}
                    onGlobalFilterChange={setSearchTerm}
                    loadingData={tabStates.Incidents.loading}
                    error={tabStates.Incidents.error}
                    setData={setIncidentData}
                    drivers={users}
                    vehicles={vehicles}
                    accountId={accountId}
                    fetchIncidents={fetchTabData}
                    typesOptions={typesOptions}
                />
            ),
        },
        {
            name: "Tires",
            component: (
                <Tires
                    vehicle={vehicle}
                    vehicleId={vehicleId}
                    accountId={accountId}
                    data={tireData}
                    setData={setTireData}
                    tirePositions={tirePositions}
                    setTirePositions={setTirePositions}
                    tireUnAssign={tireUnAssign}
                    setTireUnAssign={setTireUnAssign}
                    globalFilter={searchTerm}
                    onGlobalFilterChange={setSearchTerm}
                    fetchTires={fetchTabData}
                    loading={tabStates.Tires.loading}
                    error={tabStates.Tires.error}
                />
            ),
        },
        { name: "More", component: <div className="p-4">More Content</div> },
        {
            name: "Media",
            component: (
                <Media
                    accountId={accountId}
                    vehicleId={vehicleId}
                    media={media}
                    error={mediaError}
                    newlyAddedItem={newlyAddedItem}
                    onRemoveImage={handleRemoveImage}
                    collapsed={collapsed}
                />
            ),
        },
        // { name: "Settings", component: <Settings /> },
        {
            name: "ServiceConfig",
            component:
                <ServiceConfigs
                    loading={tabStates.ServiceConfig.loading}
                    error={tabStates.ServiceConfig.error}
                    data={serviceConfigData}
                    setData={setServiceConfigData}
                    newlyAddedItem={newlyAddedItem}
                    setNewlyAddedItem={setNewlyAddedItem}
                    globalFilter={searchTerm}
                    onGlobalFilterChange={setSearchTerm}
                    vehicles={vehicles}
                    accountId={accountId}
                    fetchServiceConfig={fetchTabData}
                />
        },
    ];

    return TABS;
};

export default VehicleViewTabsConfig; 